import axios from '_u/axios'

// 项目/客户/订单/金额统计
export const sellStatistic = () => {
    return axios.post('api/sell/statistic/sellStatistic')
}

// 近30天使用统计
export const viewStatistic = () => {
    return axios.post('api/sell/statistic/viewStatistic')
}
